// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rotate-0{transform:rotate(0deg)}.rotate-45{transform:rotate(45deg)}.rotate-90{transform:rotate(90deg)}.rotate-180{transform:rotate(180deg)}.-rotate-45{transform:rotate(-45deg)}.-rotate-90{transform:rotate(-90deg)}.-rotate-180{transform:rotate(-180deg)}", ""]);
// Exports
module.exports = exports;
